// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*{margin:0;padding:0;text-decoration:none;list-style-type:none}#app{width:100%;height:100%}.active:focus{color:red}", ""]);
// Exports
module.exports = exports;
